import { useEffect, useState } from 'react';
import { TABLE_PAGE_SIZES } from '../constants';
import { MergedCustomEvent } from '../types';

export const usePagination = (
  sortedEvents: MergedCustomEvent[],
  setPaginatedSortedEvents: (value: MergedCustomEvent[]) => void,
) => {
  const [pageSize, setPageSize] = useState(TABLE_PAGE_SIZES[0]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const startPoint = (currentPage - 1) * pageSize;
    const endPoint = Math.min(sortedEvents.length, currentPage * pageSize);

    if (startPoint >= endPoint && currentPage !== 1) {
      setPageSize(pageSize);
      setCurrentPage(1);
      setPaginatedSortedEvents(sortedEvents.slice(0, endPoint));
    } else {
      setPaginatedSortedEvents(sortedEvents.slice(startPoint, endPoint));
    }
  }, [sortedEvents, pageSize, currentPage]);

  return { pageSize, setPageSize, currentPage, setCurrentPage };
};
